import { apiClient } from "@/api/client";
import { RESPONSE_STATUSES } from "@/api/constants";
import { API_ENDPOINTS } from "@/config/app";
import type { ApiError } from "@/types/api";

import type {
  FoodicsAuthorizationTokenResponse,
  PosIntegrationResponse,
  TableIdMappingMetadata,
  UpsertPosIntegrationRequest,
} from "./types";

const basePath = `${API_ENDPOINTS.ADMIN}/pos-integration`;

export const posIntegrationApi = {
  async getByBranchId(
    branchId: string
  ): Promise<PosIntegrationResponse | null> {
    try {
      return await apiClient.get<PosIntegrationResponse>(
        `${basePath}/${branchId}`
      );
    } catch (e) {
      const err = e as ApiError;
      if (err.status === RESPONSE_STATUSES.NOT_FOUND) {
        return null;
      }
      throw e;
    }
  },

  async getFoodicsAuthorizationToken(
    branchId: string
  ): Promise<FoodicsAuthorizationTokenResponse> {
    return apiClient.get<FoodicsAuthorizationTokenResponse>(
      `${basePath}/${branchId}/foodics-authorization-token`
    );
  },

  async post(
    body: UpsertPosIntegrationRequest
  ): Promise<PosIntegrationResponse> {
    return apiClient.post<PosIntegrationResponse>(basePath, body);
  },

  async patch(
    body: UpsertPosIntegrationRequest
  ): Promise<PosIntegrationResponse> {
    return apiClient.patch<PosIntegrationResponse>(basePath, body);
  },

  async putTableIdMapping(
    branchId: string,
    file: File
  ): Promise<TableIdMappingMetadata> {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.putForm<TableIdMappingMetadata>(
      `${basePath}/${branchId}/table-id-mapping`,
      formData
    );
  },

  async downloadTableIdMapping(
    branchId: string
  ): Promise<{ blob: Blob; filename: string }> {
    return apiClient.download(`${basePath}/${branchId}/table-id-mapping`);
  },

  async deleteTableIdMapping(branchId: string): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(
      `${basePath}/${branchId}/table-id-mapping`
    );
  },
};
